import { render, staticRenderFns } from "./SimpleConfigsViewer.vue?vue&type=template&id=5f127f58&"
import script from "./SimpleConfigsViewer.vue?vue&type=script&lang=js&"
export * from "./SimpleConfigsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports